var React = require('react');

function BigStoryBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 1298.4V721.745L1337.58 0.686646V577.344L0 1298.4Z","fill":"#444444"}));
}

BigStoryBottom.defaultProps = {"width":"1169","height":"531","viewBox":"0 0 1169 531","fill":"none"};

module.exports = BigStoryBottom;

BigStoryBottom.default = BigStoryBottom;
